const minValue = 0
const maxValue = 180

export { minValue, maxValue }